<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-wrapper" @click.self="$emit('close')">
        <div class="modal-container">
          <!-- Header -->
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white p-2"
              id="fermeture"
              aria-label="Close"
              @click="$emit('close')"
            ></button>
          </div>
          <div class="modal-body p-3">
            <slot />
          </div>

          <div class="modal-footer">
            <slot name="footer">
              default footer
              <button class="modal-default-button" @click="$emit('close')">
                OK
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    show: Boolean,
    title: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150%;
  height: 100%;
}

.modal-container {
  background: #fff;
  border-radius: 8px;
  padding: 0 0 15px 0;
  max-height: 80vh; /* limite la hauteur */
  display: flex;
  flex-direction: column; /* header, body, footer en colonne */
  overflow: hidden;
}

.modal-header,
.modal-footer {
  flex-shrink: 0; /* fixes */
  padding: 10px 15px;
  border-bottom: 1px solid #ddd;
}

.modal-footer {
  border-top: 1px solid #ddd;
}

.modal-body {
  flex: 1;
  overflow-y: auto; /* scroll si le contenu est trop long */
  padding: 15px;
}

/* Scrollbar moderne */
.modal-body::-webkit-scrollbar {
  width: 6px;
}
.modal-body::-webkit-scrollbar-thumb {
  background: #bbb;
  border-radius: 4px;
}
.modal-body::-webkit-scrollbar-thumb:hover {
  background: #888;
}
</style>
